import { FC } from 'react';
import { Bull } from 'types';
import utils from 'utils';
import { ObjectView, TableView } from 'components/Avaliations';
import { objectFilter, objectIs } from 'object-fn-ts';
import { Stack, Typography } from '@mui/material';

type Props = {
  bull: Bull;
  selectedProof?: any;
  selectedProofData?: any[] | any | { [key: string]: string };
  proofObject?: any;
  hasCarcaca?: boolean;
  carcacaName?: string;
};

/* corte europeu - component rendering */
const ZCBullDetails: FC<Props> = ({
  selectedProof,
  selectedProofData,
  bull,
  hasCarcaca,
  carcacaName,
}) => {
  return (
    <>
      {hasCarcaca &&
        selectedProof !== ' ' &&
        carcacaName === selectedProof &&
        utils.segmentFromBullOrBreed(bull) === 'zc' &&
        selectedProofData !== null && (
        <>
          <Stack
            {...utils.stack.flex.col('flex-start', 'center')}
            spacing={2}
            sx={utils.sx.fw}
          >
            <Typography>{selectedProof}</Typography>
          </Stack>
          <ObjectView data={selectedProofData} title={carcacaName} />
        </>
      )}
      {selectedProof !== ' ' &&
        selectedProofData !== null &&
        carcacaName !== selectedProof &&
        utils.segmentFromBullOrBreed(bull) === 'zc' && (
        <>
          <Stack
            {...utils.stack.flex.col('flex-start', 'center')}
            spacing={2}
            sx={utils.sx.fw}
          >
            <Typography>{selectedProof}</Typography>
          </Stack>
          <TableView
            data={selectedProofData.table as any}
            comp={(() => {
              const comp = objectFilter(
                selectedProofData,
                (_, val) => objectIs(val) && 'REB' in val && 'FILHOS' in val
              );
              return {
                cz: Object.entries(comp).map(([ key, val ]) => ({
                  name: key,
                  val,
                })),
              };
            })()}
          />
        </>
      )}
    </>
  );
};

export default ZCBullDetails;
